module.exports = __webpack_public_path__ + "img/super-selected-4f8dbb63.png";